import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import VueCookies from "vue3-cookies";
import {createHead} from "@vueuse/head";
import VueLazyLoad from "vue3-lazyload";

// 설치했던 fontawesome-svg-core와 vue-fontawesome
import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
// 설치했던 아이콘파일에서 해당 아이콘만 불러옵니다.
import {fas} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import {fab} from "@fortawesome/free-brands-svg-icons";

import config from "@/config/config";

// 불러온 아이콘을 라이브러리에 담습니다.
library.add(fas, far, fab);

const head = createHead();

const app = createApp(App);

// 전역변수 설정
app.config.globalProperties.$config = config;

app
  .use(store)
  .use(router)
  .use(head)
  // .use(VueCookies, {
  //   expireTimes: "30d",
  //   domain: "; domain=.toptoon.biz",
  // })
  .use(VueLazyLoad, {loading: "/assets/images/home/lazyLoading.png", error: ""})
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");

// 전역변수 TS2339 에러 방지위한 Type 선언
declare module "@vue/runtime-core" {
  export interface ComponentCustomProperties {
    $config: typeof config;

    $route: import("vue-router").RouteLocationNormalizedLoaded;
    $router: import("vue-router").Router;
  }
}
